import type { CollectionReference, DocumentReference } from 'firebase/firestore'
import {
  collection,
  type FirestoreDataConverter,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import type { FirestoreClickWrap } from '../ClickWrap/schema'
import type { FirestoreClickWrapUpdate } from './schema'
import { schema } from './schema'

const converter: FirestoreDataConverter<FirestoreClickWrapUpdate> = {
  toFirestore: (data) => {
    return data
  },
  fromFirestore: (snapshot: QueryDocumentSnapshot) => {
    const data = snapshot.data({ serverTimestamps: 'estimate' })
    return schema.parse(data)
  },
}

export const getColRef = (
  ref: DocumentReference<FirestoreClickWrap>
): CollectionReference<FirestoreClickWrapUpdate> => {
  return collection(ref, 'update').withConverter(converter)
}
